import { makeRequest, Service, identify } from 'utils/http';

export async function getExternalUsersAPI() {
  return makeRequest(Service.getAllExternalUsers(await identify()));
}
